/**
 * @desc ebs处理结果
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.EbsFeedBackResponseDto>;
export function request(body: defs.basics.EbsFeedBackRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/ebs/ebsResult`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
